import React, { Component } from 'react';
import './App.css';
import Routes from "./Routes";
import logo from './DVLA_app_shape_grey_surround.svg';


class App extends Component {

  render() {
    return (
          <div className="container-fluid">
            <h3 className="App-title">
                <img src={logo} className="img-responsive center-block App-logo" alt="logo" />
            </h3>
            <Routes />
        </div>
    );
  }
}

export default App;



// WEBPACK FOOTER //
// ./src/App.js